import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { LocationModel, ResellerModel, UserModel } from '@models/index';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppFacadeService } from '@services/app-facade.service';
import { LocationsFacadeService } from '@services/locations/locations-facade.service';
import { ResellersFacadeService } from '@services/resellers/resellers-facade.service';
import { ReviewsFacadeService } from '@services/reviews/reviews-facade.service';
import { UsersService } from '@services/users/users.service';
import { NEVER, Subscription } from 'rxjs';
import { hideIntercom, showIntercom, showIntercomChat } from '@utilities/function-utils';


@Component({
  selector: 'app-generate-reply',
  templateUrl: './generate-reply.component.html',
  styleUrls: ['./generate-reply.component.sass']
})
export class GenerateReplyComponent implements OnInit, OnDestroy {
  userLogged: UserModel
  location: LocationModel;
  reseller: ResellerModel;
  _subs: Subscription = NEVER.subscribe()
  loggedUser: UserModel;


  constructor(
    public activeModal: NgbActiveModal,
    private reviewsFacadeService: ReviewsFacadeService,
    private locationsFacadeService: LocationsFacadeService,
    private resellerService: ResellersFacadeService,
    private appFacadeService: AppFacadeService,
  ) {

  }

  ngOnInit(): void {
    this._subs.add(
      this.locationsFacadeService
        .getCurrentLocation$()
        .subscribe(item => this.location = item)
    )

    this._subs.add(
      this.resellerService.
        getSelectedReseller$()
        .subscribe(item => this.reseller = item)
    )
    this._subs.add(
      this.appFacadeService
        .getLoggedUser$()
        .subscribe(user => this.userLogged = user)
    )
    this._subs.add(
      this.appFacadeService.getLoggedUser$()
        .subscribe(user => {
          this.loggedUser = user;
        })
    )
  }
  addOn() {
    if (environment.intercomResellerId == this.reseller.id) {
      showIntercom(this.loggedUser)
      showIntercomChat(this.loggedUser)
    } else {
      this.reviewsFacadeService.addOnOpenAi({
        reselerId: this.reseller.id,
        businessId: this.location.businessId,
        locationId: this.location.id,
        userId: this.userLogged.id
      })
    }
    this.activeModal.dismiss()
  }
  ngOnDestroy(): void {
    if (this._subs) this._subs.unsubscribe()
  }

}
